import React from "react";
import MainRouter from "@features/Layout/MainRouter";
import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import EXFALoader from "@components/EXFALoader";
import { DestMarketProvider } from "@context/destMarketContext";
import { ContextProvider } from "@context/statsContext";
import { ConstantsProvider } from "@context/constantsContext";
import { MarketsProvider } from "@context/marketsContext";
import { RangerProvider } from "@context/rangerContext";

const MainApp = () => (
  <>
    <ContextProvider>
      <MarketsProvider>
        <RangerProvider>
          <ConstantsProvider>
            <DestMarketProvider>
              <EXFALoader />
              <ReactNotification />
              <MainRouter />
            </DestMarketProvider>
          </ConstantsProvider>
        </RangerProvider>
      </MarketsProvider>
    </ContextProvider>
  </>
);

export default MainApp;
